<div class="">

    <div class="title-tab-step text-center">
        {{ 'SecLogins' | translate }}
        <i class="fa fa-plus fa-1x icons-style" aria-hidden="true" placement="left" ngbTooltip="{{ 'ADD' | translate }}"
            (click)="addEditRow(null)"></i>
    </div>
    <!--search area-->
    <div class="ui-widget-header search-area">
        <div class="col-3 p-0 mb-1">
            <input #gb class="form-control" type="text" pInputText size="30" placeholder="{{ 'FILTER' | translate }}">
        </div>
    </div>

    <div class="container-fluid p-0">
        <div class="">
            <div class="">
                <p-dataTable class="table table-responsive" tableStyleClass="table table-bordered table-hover table-striped"
                    (onRowClick)="onRowSelect($event)" [value]="SecLogins" [selectionMode]="'single'" [rows]="10"
                    [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]" [globalFilter]="gb">
                    <p-column field="id" header="{{ 'ID' | translate }}" [sortable]="true"></p-column>
                    <p-column field="usersUserName" header="{{ 'USERNAME' | translate }}" [sortable]="true"></p-column>
                    <p-column field="branchNameAr" header="{{ 'BRANCHNAME' | translate }}" [sortable]="true"></p-column>
                    <p-column field="active" styleClass="col-button" header="{{ 'ACTIVE' | translate }}">
                        <!-- <ng-template pTemplate="options" let-row="rowData">
                            <i class="fa dataTableFa" [ngClass]="{'fa-check-square': row['active'] == true,'fa-square-o':row['active'] == false}"></i>
                        </ng-template> -->
                        <ng-template pTemplate="options" let-row="rowData">
                            <div class="form-check">
                                <label class="custom-control custom-checkbox" [attr.for]="id">
                                    <input type="checkbox" name="x{{row}}" [(ngModel)]="row['active']" class="custom-control-input" [id]="id" (click)="updateStatus(row)"/>
                                    <span class="custom-control-indicator"></span>
                                    <span class="custom-control-description"></span>
                                </label>
                            </div>
                        </ng-template>
                    </p-column>
                </p-dataTable>
            </div>
        </div>
    </div>
</div>

<block-modal-container #popup (close)="onpopupClose($event)">
    <ng-container class="modal-title">
    </ng-container>
    <ng-container class="modal-body" [ngComponentOutlet]="DynamicComponent"></ng-container>
</block-modal-container>